module.exports = __webpack_public_path__ + "img/vino-mark.edd97f82.svg";